// 获取七牛云token
export function getToken() {
  return getFetchData({
    url: 'user/getQNToken',
    method: 'GET'
  })
}

// 七牛上传图片
export const uploadIMG = (data: FormData) => {
  return getFetchData({
    url: 'https://up-as0.qiniup.com',
    method: 'POST',
    data,
    isFormData: true
  })
}
